import updateObject from '@/components/mixins/UpdateObject.js'
import { ISOlanguages } from '@/router/globals.js'

export const ResourceData = [
  {
    label: 'Type & Title',
    type: 'title',
    class: 'has-Icon',
  },
  {
    label: 'Description',
    type: 'description',
    class: '',
  },
  {
    label: 'star',
    type: 'featured',
    class: 'icon',
  },
  {
    label: 'Sector',
    type: 'sector',
    class: '',
  },
  {
    label: ISOlanguages,
    type: 'languages',
    class: 'postsTable__Languages',
  },
  {
    label: 'Issue',
    type: 'issue',
    class: '',
  },
  {
    label: 'Affiliate',
    type: 'organisation',
    class: '',
  },
  {
    label: 'Country',
    type: 'country',
    class: '',
  },
  {
    label: 'Inserted',
    type: 'date',
    class: '',
  },
  {
    label: 'Last update',
    type: 'updated',
    class: '',
  },
]

export const ClausesData = [
  {
    label: 'Clause ID',
    type: 'contents.additionals.clause_properties.id',
  },
  {
    label: 'Title',
    type: 'title',
  },
  {
    label: ISOlanguages,
    type: 'languages',
    class: 'postsTable__Languages',
  },
  {
    label: 'Theme',
    type: 'clause_theme',
  },
  {
    label: 'Affiliate',
    type: 'organisation',
  },
  {
    label: 'Sector',
    type: 'sector',
  },
  {
    label: 'Country',
    type: 'country',
  },
  {
    label: 'Type',
    type: 'clause_type',
  },
  {
    label: 'Inserted',
    type: 'date',
  },
  {
    label: 'Last update',
    type: 'updated',
    class: '',
  },
]

export const CampaignData = [
  {
    label: 'Campaign name',
    type: 'title',
    class: '',
  },
  {
    label: 'star',
    type: 'featured',
    class: 'icon',
  },
  {
    label: 'Sector',
    type: 'sector',
    class: '',
  },
  {
    label: 'Issue',
    type: 'issue',
    class: '',
  },
  {
    label: 'Affiliate',
    type: 'organisation',
    class: '',
  },
  {
    label: 'Country',
    type: 'country',
    class: '',
  },
  {
    label: 'Visibility',
    type: 'status',
    class: '',
  },
  {
    label: 'Inserted',
    type: 'date',
    class: '',
  },
  {
    label: 'Last update',
    type: 'updated',
    class: '',
  },
  {
    label: 'Endorsements',
    type: 'endorsements',
    class: '',
  },
]

export const EventData = [
  {
    label: 'Date & Title',
    type: 'title',
    class: 'has-Icon',
  },
  {
    label: ISOlanguages,
    type: 'languages',
    class: 'postsTable__Languages',
  },
  {
    label: 'star',
    type: 'featured',
    class: 'icon',
  },
  {
    label: 'Sector',
    type: 'sector',
    class: '',
  },
  {
    label: 'Issue',
    type: 'issue',
    class: '',
  },
  {
    label: 'Affiliate',
    type: 'organisation',
    class: '',
  },
  {
    label: 'Country',
    type: 'country',
    class: '',
  },
  {
    label: 'Inserted',
    type: 'date',
    class: '',
  },
  {
    label: 'Last update',
    type: 'updated',
    class: '',
  },
]

// Extend NewsData from ResourceData
export const NewsData = ResourceData.map((a) => Object.assign({}, a))

// Replace title in NewsData
updateObject(
  { label: 'Title & Source', class: '' },
  NewsData.find((x) => x.type === 'title')
)
